import React, { Component } from 'react';
import DataTablesCreate from '../components/DataTablesCreate';
import { ApiClient, ApiResponse } from '../libs/apiClient';
import { DISPATCH_ID, SERVICE_RESPONSE } from '../libs/utils/Const';
import { connect } from 'react-redux';
import '../css/dataTables.css';
import $ from 'jquery';

let headers = [
    { title: 'Código' },
    { title: 'Nombre' }
];
let apiClient = ApiClient.getInstance();
class PartnerCreateModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchInTable: ''
        }
    }

    componentDidMount() {
        this.closeAction();
    }

    closePartner = async () => {
        $('#partnerCreate').modal('hide');
    };

    closeAction = () => {
        const { cleanData } = this.props;
        $('#partnerCreate').on('hide.bs.modal', function () {
            cleanData();
        });
    };

    searchPartners = async (card = '', PageNumber) => {
        const { enableSpinner, type, refreshPartner, newOrderModel = {}, view = '' } = this.props;
        let newView = newOrderModel?.newView || view || '';
        let businesPartnerResponse;
        if (card !== '') {
            businesPartnerResponse = await apiClient.getPartnerListCreate(type, card, PageNumber, newView);
        } else {
            enableSpinner(true);
            businesPartnerResponse = await apiClient.getPartnerListCreate(type, card, PageNumber, newView);
            enableSpinner(false);
        }

        if (businesPartnerResponse.status === SERVICE_RESPONSE.SUCCESS) {
            refreshPartner(businesPartnerResponse.data.results, businesPartnerResponse.data.totalPage);
        }

    };


    render() {
        const { data, selectPartner, totalPage, newOrderModel, indexPurchaseRequest } = this.props;
        let CardCode = '';
        if (newOrderModel) {
            CardCode = newOrderModel.CardCode || '';
        }

        if (data.length === 0) {
            return <div className="modal fade bd-example-modal-lg scroll bgtransparent" id="partnerCreate"></div>;
        }

        return (
            <div className="modal fade bd-example-modal-lg modal-open scroll"
                id="partnerCreate"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                style={{ zIndex: 1055 }}
                aria-hidden="true">

                <div className="modal-dialog modal-lg modal-open" role="document">
                    <div className="modal-content">

                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">
                                Socio de Negocios
                            </h4>
                            <button type="button" className="close" onClick={this.closePartner} aria-label="Close">
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div className="modal-body" >
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div className="table-responsive">
                                            <table className="table response" style={{ marginBottom: 0 }}>
                                                <tbody>
                                                    <DataTablesCreate
                                                        data={data}
                                                        totalPage={totalPage}
                                                        headers={headers}
                                                        view={"partnerModal"}
                                                        action={selectPartner}
                                                        search={this.searchPartners}
                                                        searchInTable={CardCode}
                                                        indexPurchaseRequest={indexPurchaseRequest}
                                                    />
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white" onClick={this.closePartner} >Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PartnerCreateModal);